module.exports = __webpack_public_path__ + "img/turbo_on.4896ec0b.png";